import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQueryWithPersisted } from './helpers/baseQueryWithPersisted';

export const graphqlApiWithPersisted = createApi({
  reducerPath: 'graphqlApiWithPersisted',
  baseQuery: baseQueryWithPersisted,
  endpoints: () => ({}),
});
